module.exports = __webpack_public_path__ + "static/media/camera.dd556904.svg";